import { render, staticRenderFns } from "./routerViewIndustry.vue?vue&type=template&id=1f2f4c14"
import script from "./routerViewIndustry.vue?vue&type=script&lang=js"
export * from "./routerViewIndustry.vue?vue&type=script&lang=js"
import style0 from "./routerViewIndustry.vue?vue&type=style&index=0&id=1f2f4c14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports